import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  Image,
  Menu,
  Spinner,
  Text,
  Tooltip,
  useBreakpointValue,
  useDisclosure,
  VStack
} from "@chakra-ui/react"
import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import {
  useLogout,
  useSetActivePortfolio,
  useUserDetails
} from "../hooks/useAuthQueries"
import { usePortfolios } from "../hooks/usePortfolioQueries"

// Icon components
const icons = {
  dashboard: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
    </svg>
  ),
  criteria: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
    </svg>
  ),
  portfolio: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
    </svg>
  ),
  explore: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </svg>
  ),
  notifications: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
    </svg>
  ),
  settings: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" />
    </svg>
  ),
  logout: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
    </svg>
  ),
  hamburger: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF">
      <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
    </svg>
  ),
  close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  ),
  market: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.34 3-3 3s-3-1.34-3-3H5V5h14v10z" />
    </svg>
  ),
  deals: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14H5v-4h7v4zm0-6H5V7h7v4zm7 6h-5v-4h5v4zm0-6h-5V7h5v4z" />
    </svg>
  ),
  getStarted: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
    </svg>
  )
}

const ChevronDownIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
    <path d="M7 10l5 5 5-5z" />
  </svg>
)

const SidebarPortfolioSwitcher: React.FC = () => {
  const navigate = useNavigate()
  const { data: userDetails } = useUserDetails()
  const { data: portfolios = [] } = usePortfolios()
  const setActivePortfolioMutation = useSetActivePortfolio()

  const [open, setOpen] = useState(false)

  const activeId = userDetails?.data?.activePortfolioId
  const activePortfolio = portfolios.find((p) => p.id === activeId)
  const displayName = activePortfolio?.name ?? "Portfolio"

  const handleOpenChange = (details: { open: boolean }) => {
    setOpen(details.open)
  }

  return (
    <Menu.Root
      open={open}
      onOpenChange={handleOpenChange}
      closeOnSelect={false}
    >
      <Menu.Trigger asChild>
        <Button
          variant="unstyled"
          display="flex"
          w="full"
          px={4}
          py={3}
          h="auto"
          borderRadius="lg"
          border="1px solid"
          borderColor="whiteAlpha.300"
          color="white"
          bg="transparent"
          _hover={{ bg: "#1D4339" }}
          _active={{ bg: "#1D4339" }}
          justifyContent="flex-start"
        >
          <HStack gap={2} w="full" justify="space-between">
            <Text fontSize="sm" fontWeight="medium" color="white" truncate>
              {displayName}
            </Text>
            <Icon color="whiteAlpha.600" flexShrink={0}>
              <ChevronDownIcon />
            </Icon>
          </HStack>
        </Button>
      </Menu.Trigger>
      <Menu.Positioner width="var(--reference-width)">
        <Menu.Content
          width="100%"
          zIndex={1100}
          bg="#1D4339"
          borderRadius="md"
          border="1px solid"
          borderColor="whiteAlpha.300"
          boxShadow="0 8px 24px rgba(0,0,0,0.4)"
        >
          {portfolios.map((p) => (
            <Menu.Item
              key={p.id}
              value={String(p.id)}
              fontWeight={p.id === activeId ? "bold" : "normal"}
              color="white"
              borderRadius="md"
              bg="transparent"
              cursor="pointer"
              _hover={{ bg: "#132e26" }}
              onClick={() => {
                setActivePortfolioMutation.mutate(p.id)
                setOpen(false)
              }}
            >
              {p.name}
            </Menu.Item>
          ))}
          <Menu.Separator borderColor="green.900" />
          <Menu.Item
            value="__create__"
            color="white"
            fontWeight="medium"
            bg="transparent"
            cursor="pointer"
            _hover={{ bg: "#1D4339" }}
            onClick={() => {
              setOpen(false)
              navigate("/create-portfolio")
            }}
          >
            + New portfolio
          </Menu.Item>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  )
}

const sourcingEnabled = process.env.REACT_APP_SOURCING_ENABLED === "true"

function buildMenuItems(isPropertyInvestment: boolean) {
  return [
    ...(!isPropertyInvestment
      ? [{ label: "Dashboard", icon: icons.dashboard, path: "/dashboard" }]
      : []),
    {
      label: isPropertyInvestment ? "Portfolio" : "My Homes",
      icon: isPropertyInvestment ? icons.portfolio : icons.explore,
      path: isPropertyInvestment ? "/portfolio" : "/my-homes"
    },
    ...(isPropertyInvestment && sourcingEnabled
      ? [
          {
            label: "Opportunities",
            icon: icons.market,
            path: "/opportunities"
          },
          { label: "Pipeline", icon: icons.deals, path: "/pipeline" },
          { label: "My Criteria", icon: icons.criteria, path: "/criteria" }
        ]
      : [])
  ]
}

interface MenuItemProps {
  icon: React.ReactNode
  label: string
  isActive?: boolean
  onClick: () => void
  badge?: number
}

const MenuItem: React.FC<MenuItemProps> = ({
  icon,
  label,
  isActive,
  onClick,
  badge
}) => (
  <Flex
    align="center"
    px={4}
    py={3}
    cursor="pointer"
    borderRadius="lg"
    bg={isActive ? "#1D4339" : "transparent"}
    color="white"
    _hover={{
      bg: isActive ? "#1D4339" : "green.900",
      color: "white"
    }}
    onClick={onClick}
    position="relative"
    w="100%"
    justify="flex-start"
  >
    <Icon as="span" mr={3}>
      {icon}
    </Icon>
    <Text fontSize="sm" fontWeight="medium" textAlign="left">
      {label}
    </Text>
    {badge && (
      <Box
        position="absolute"
        right={4}
        bg="red.500"
        color="white"
        borderRadius="full"
        px={2}
        py={0.5}
        fontSize="xs"
        fontWeight="bold"
        minW="20px"
        textAlign="center"
      >
        {badge}
      </Box>
    )}
  </Flex>
)

const MobileMenuBar: React.FC<{ isOpen: boolean; onToggle: () => void }> = ({
  isOpen,
  onToggle
}) => (
  <Box
    position="fixed"
    top={0}
    left={0}
    right={0}
    zIndex={1001}
    display={{ base: "block", lg: "none" }}
    bg="#32544A"
    borderBottom="2px solid"
    borderColor="#32544A"
  >
    <Flex align="center" justify="space-between" px={4} py={3}>
      <Box
        as="button"
        onClick={onToggle}
        color="#32544A"
        p={2}
        borderRadius="md"
        _hover={{ bg: "green.900" }}
      >
        <Icon as="span">{isOpen ? icons.close() : icons.hamburger()}</Icon>
      </Box>
      <Image src="/images/logo-icon.png" alt="Logo" h="40px" />
      <Box w="40px" />
    </Flex>
  </Box>
)

const UserProfile: React.FC<{
  userDetails: any
  isSettingsActive: boolean
  onSettings: () => void
  onLogout: () => void
}> = ({ userDetails, isSettingsActive, onSettings, onLogout }) => {
  const org = userDetails?.data?.organisation
  const current = org?.totalHomes ?? 0
  const limit = org?.homeQuota ?? 0
  const pct = limit > 0 ? Math.min((current / limit) * 100, 100) : 0
  const isReached = current >= limit && limit > 0
  const barColor = isReached
    ? "rgba(252,129,129,0.7)"
    : current >= limit * 0.8
      ? "rgba(246,173,85,0.7)"
      : "rgba(154,230,180,0.5)"

  return (
    <Box px={4} py={6}>
      <HStack gap={3} mb={3}>
        <Box
          w="40px"
          h="40px"
          borderRadius="full"
          bg="green.600"
          display="flex"
          alignItems="center"
          justifyContent="center"
          color="white"
          fontSize="sm"
          fontWeight="bold"
          flexShrink={0}
        >
          {userDetails?.data.firstName.charAt(0)}
          {userDetails?.data.lastName.charAt(0)}
        </Box>
        <VStack align="start" gap={0} flex={1} minW={0}>
          <Text fontSize="sm" fontWeight="medium" color="white" truncate>
            {userDetails?.data &&
              `${userDetails.data.firstName} ${userDetails.data.lastName}`}
          </Text>
          <Text fontSize="xs" color="green.300" truncate>
            {org?.name}
          </Text>
        </VStack>
      </HStack>

      {limit > 0 && (
        <Tooltip.Root openDelay={200} closeDelay={100}>
          <Tooltip.Trigger asChild>
            <Box
              mb={3}
              cursor="default"
              // border="1px solid"
              // borderColor="rgba(255,255,255,0.12)"
              borderRadius="md"
              px={6}
              py={0}
            >
              <HStack justify="space-between" mb={1}>
                <Text fontSize="xs" color="white">
                  Plan limit
                </Text>
                <Text fontSize="xs" color="white">
                  {current}/{limit} homes
                </Text>
              </HStack>
              <Box
                h="3px"
                bg="rgba(255,255,255,0.1)"
                borderRadius="full"
                overflow="hidden"
              >
                <Box
                  h="100%"
                  w={`${pct}%`}
                  bg={barColor}
                  borderRadius="full"
                  transition="all 0.3s ease"
                />
              </Box>
            </Box>
          </Tooltip.Trigger>
          <Tooltip.Positioner>
            <Tooltip.Content maxW="260px">
              {isReached
                ? `Quota reached (${current}/${limit}). Contact us to increase your limit.`
                : `🚀 Beta Version: We're currently limiting the number of homes to ensure optimal performance. (${current}/${limit})`}
            </Tooltip.Content>
          </Tooltip.Positioner>
        </Tooltip.Root>
      )}

      <MenuItem
        icon={icons.settings()}
        label="Settings"
        isActive={isSettingsActive}
        onClick={onSettings}
      />
      <MenuItem icon={icons.logout()} label="Log Out" onClick={onLogout} />
    </Box>
  )
}

const LeftMenu: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { logout: authLogout } = useAuth()
  const { data: userDetails, isLoading } = useUserDetails()
  const { data: portfolios } = usePortfolios()
  const activePortfolioId = userDetails?.data?.activePortfolioId
  const logoutMutation = useLogout()
  const { open, onOpen, onClose } = useDisclosure()
  const isMobile = useBreakpointValue({ base: true, lg: false })

  const handleLogout = async () => {
    try {
      await logoutMutation.mutateAsync()
      authLogout()
      navigate("/login")
    } catch (error) {
      console.error("Logout failed:", error)
    }
  }

  const isPropertyInvestment =
    userDetails?.data?.organisation?.organisationType === "property_investment"
  const isOnboarding =
    !isLoading &&
    isPropertyInvestment &&
    !userDetails?.data?.organisation?.isOnboarded
  const menuItems = buildMenuItems(isPropertyInvestment)

  const handleMenuItemClick = (path: string) => {
    navigate(path)
    if (isMobile) {
      onClose()
    }
  }

  return (
    <>
      <MobileMenuBar isOpen={open} onToggle={open ? onClose : onOpen} />

      {/* Mobile Overlay */}
      {isMobile && open && (
        <Box
          position="fixed"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bg="blackAlpha.600"
          zIndex={999}
          onClick={onClose}
        />
      )}

      {/* Menu Content */}
      <Box
        bg="#32544A"
        w={{ base: "100%", lg: "280px" }}
        h={{ base: "100vh", lg: "calc(100vh)" }}
        position={{ base: "fixed", lg: "fixed" }}
        left={{ base: 0, lg: 0 }}
        top={{ base: 0, lg: 0 }}
        display={{ base: open ? "flex" : "none", lg: "flex" }}
        flexDirection="column"
        color="green.50"
        zIndex={1000}
      >
        {/* Logo - Desktop Only */}
        <Flex
          align="center"
          justify="center"
          py={6}
          display={{ base: "none", lg: "flex" }}
        >
          <Image src="/images/logo-icon.png" alt="Logo" h="60px" />
        </Flex>

        {/* Portfolio Switcher */}
        {!isOnboarding && (
          <Box px={4} pb={2} display={{ base: "none", lg: "block" }}>
            <SidebarPortfolioSwitcher />
          </Box>
        )}

        {/* Navigation Menu */}
        <VStack gap={1} px={4} flex={1} pt={{ base: 24, lg: 0 }}>
          {isOnboarding ? (
            <MenuItem
              icon={icons.getStarted()}
              label="Get started"
              isActive={location.pathname === "/welcome"}
              onClick={() => handleMenuItemClick("/welcome")}
            />
          ) : (
            menuItems.map((item) => (
              <MenuItem
                key={item.label}
                icon={item.icon()}
                label={item.label}
                isActive={location.pathname === item.path}
                onClick={() => handleMenuItemClick(item.path)}
                badge={item.badge}
              />
            ))
          )}
        </VStack>

        {/* User Profile Section */}
        {isLoading ? (
          <Box p={8} display="flex" justifyContent="center" alignItems="center">
            <Spinner size="xl" />
          </Box>
        ) : (
          <UserProfile
            userDetails={userDetails}
            isSettingsActive={location.pathname === "/settings"}
            onSettings={() => handleMenuItemClick("/settings")}
            onLogout={handleLogout}
          />
        )}
      </Box>
    </>
  )
}

export default LeftMenu
